import e from "react";
import { componentName as t } from "../../../utils/bem/index.js";
import { SelectableList as a } from "../../lists/SelectableList/index.js";
import { TextField as s } from "../TextField/TextField.js";
function o(o) {
  var n,
    l = t("typeahead", o.className, {
      open: o.open,
      hasSuggestion: null === (n = o.suggestions) || void 0 === n ? void 0 : n.length,
      disabled: o.disabled
    });
  return e.createElement("div", {
    className: l
  }, e.createElement(s, {
    className: "typehead__input_wrapper",
    value: o.value,
    onChange: o.onChange,
    placeholder: o.placeholder,
    disabled: o.disabled,
    onFocus: o.onFocus,
    onBlur: o.onBlur,
    autoFocus: o.autoFocus
  }, o.children), o.open && !o.disabled && e.createElement(a, {
    onKeyboardEvent: function onKeyboardEvent(e) {
      return e.preventDefault();
    },
    enableKeyboardNavigation: !0,
    className: "typeahead__suggestions-list",
    template: o.suggestionsTemplate,
    onItemPicked: o.onItemPicked,
    items: o.suggestions
  }));
}
export { o as TypeaheadStateless };